import { render, staticRenderFns } from "./ProjectsToolbarControls.vue?vue&type=template&id=754b15fc&scoped=true"
import script from "./ProjectsToolbarControls.vue?vue&type=script&lang=js"
export * from "./ProjectsToolbarControls.vue?vue&type=script&lang=js"
import style0 from "./ProjectsToolbarControls.vue?vue&type=style&index=0&id=754b15fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b15fc",
  null
  
)

export default component.exports